<template>
  <div class="container has-text-centered">
    <!-- <div class="container has-text-centered">
      <div class="column is-4 is-offset-4">
        <h3 class="title has-text-black">Login</h3>
        <p class="subtitle has-text-grey">Please login to proceed.</p>
        <div class="box">
          <form>
            <div class="field">
              <div class="control">
                <input
                  v-model="form.email"
                  @blur="$v.form.email.$touch()"
                  class="input is-large"
                  type="email"
                  placeholder="Your Email"
                  autofocus
                  autocomplete="email"
                />

                <div v-if="$v.form.email.$error" class="form-error">
                  <span v-if="!$v.form.email.required" class="help is-danger"
                    >Email is Required</span
                  >
                  <span v-if="!$v.form.email.email" class="help is-danger"
                    >Email Address is not Valid</span
                  >
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  v-model="form.password"
                  @blur="$v.form.password.$touch()"
                  class="input is-large"
                  type="password"
                  placeholder="Your Password"
                  autocomplete="current-password"
                />

                <div v-if="$v.form.email.$error" class="form-error">
                  <span v-if="!$v.form.email.required" class="help is-danger"
                    >Password is Required</span
                  >
                </div>
              </div>
            </div>
            <button
              @click.prevent="login"
              :disabled="isFormInvalid"
              class="button is-block is-info is-large is-fullwidth"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>-->
    <section class="hero is-fullheight">
      <div class="hero-body has-text-centered">
        <div class="login">
          <a href="#">
            <img
              style="padding: 10px"
              src="../assets/login.png"
              width="300px"
            />
          </a>
          <div style="margin-top: 30px"></div>
          <form>
            <div class="field">
              <div class="control">
                <input
                  class="input is-medium is-rounded"
                  type="email"
                  v-model="form.email"
                  @blur="$v.form.email.$touch()"
                  placeholder="admin@example.com"
                  autocomplete="username"
                />

                <div v-if="$v.form.email.$error" class="form-error">
                  <span v-if="!$v.form.email.required" class="help is-danger"
                    >Email is Required</span
                  >
                  <span v-if="!$v.form.email.email" class="help is-danger"
                    >Email Address is not Valid</span
                  >
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  class="input is-medium is-rounded"
                  type="password"
                  placeholder="**********"
                  autocomplete="current-password"
                  v-model="form.password"
                  @blur="$v.form.password.$touch()"
                />
                <div v-if="$v.form.password.$error" class="form-error">
                  <span v-if="!$v.form.email.required" class="help is-danger"
                    >Password is Required</span>
                </div>
              </div>
            </div>
            <br />
            <button
              class="button is-block is-fullwidth is-primary is-medium is-rounded"
              @click.prevent="login"
              :disabled="isFormInvalid"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                :custom-size="[{ 'fa-lg': isLoading }]"
                :custom-class="[{ 'fa-spin': isLoading }]"
              ></b-icon>
              <span style="margin-left: 15px">Login</span>
            </button>
          </form>
          <br />
          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <router-link to="/forgetPassword">
                  <a>Forgot Password?</a>
                </router-link>
              </div>
            </div>
            <!-- <div class="level-item has-text-centered">
              <div>
                <a href="#">Create an Account</a>
              </div>
            </div>-->
          </nav>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      isLoading: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  computed: {
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
  },
  methods: {
    login() {
      this.$v.form.$touch();
      this.isLoading = true;
      this.$store
        .dispatch('auth/loginWithEmailAndPassword', this.form)
        .then(() => {
          this.$router.push('/');
          this.isLoading = false;
        })
        .catch((errMessage) => {
          // console.log(errMessage);
          this.$buefy.snackbar.open({
            message: `Login Failed ${errMessage}`,
            queue: false,
          });
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

@media screen and (min-width: 1024px) {
  .container {
    padding-right: 12rem;
  }
}

.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
/* .box {
  margin-top: 5rem;
} */
/* .avatar {
  margin-top: -70px;
  padding-bottom: 20px;
} */
/* .avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
} */
/* input {
  font-weight: 300;
} */
/* p {
  font-weight: 700;
} */
/* p.subtitle {
  padding-top: 1rem;
} */

/* .login-hr {
  border-bottom: 1px solid black;
} */

/* .has-text-black {
  color: black;
} */

/* .field {
  padding-bottom: 10px;
} */
/* 
.fa {
  margin-left: 5px;
} */
/* 
* {
  font-family: 'Nunito Sans', sans-serif;
} */

.hero-body {
  justify-content: center;
}

.login {
  border-radius: 25px;
  padding: 1.5rem;
  box-shadow: 2px 2px 2px #0372bb, -2px -2px 4px #0372bb;
}

.background {
  background-color: #1d1e21;
}

a {
  font-weight: 600;
}

.button.is-primary {
  background-color: #0372bb;
  border-color: transparent;
  color: #fff;
}
</style>
